module.exports = __webpack_public_path__ + "static/media/DSCF0248-GQpoiYgs.d33022b8.JPG";